import { baseStudyEntityValidationSchema } from './validation/index.js';
import { z } from 'zod';
export const sortableEntitySchema = z.object({
    ...baseStudyEntityValidationSchema.shape,
    sequenceNumber: z.number().int().min(1),
});
//# sourceMappingURL=sortable-entity.js.map